import { FormattedMessage } from 'react-intl';

export const BuckleNotIncluded = (
  <FormattedMessage
    defaultMessage='Buckle sold separately'
    id='strapAddToBagModal.buckleNotIncluded'
  />
);
